import React from 'react';
import { Layout } from 'react-admin';
import MyAppBar from './MyAppBar';
import MySidebar from './MySidebar';
import MyMenu from './MyMenu';

const AdminLayout = (props) => (
    <Layout {...props} appBar={MyAppBar} sidebar={MySidebar} menu={MyMenu} />
);

export default AdminLayout;
